import { render, staticRenderFns } from "./EquipeUsuarioAssociacaoPage.vue?vue&type=template&id=296897da&scoped=true"
import script from "./EquipeUsuarioAssociacaoPage.vue?vue&type=script&lang=js"
export * from "./EquipeUsuarioAssociacaoPage.vue?vue&type=script&lang=js"
import style0 from "./EquipeUsuarioAssociacaoPage.vue?vue&type=style&index=0&id=296897da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296897da",
  null
  
)

export default component.exports